import * as React from 'react';
import { ArticleHeading4, ArticleParagraph2 } from '@cian/ui-kit/typography';

import * as styles from './styles.css';
import { LinkButton } from '@cian/ui-kit';

export function FlatsError(): React.JSX.Element {
  return (
    <div className={styles['container']}>
      <div className={styles['image']} />
      <div className={styles['title']}>
        <ArticleHeading4 color="text-primary-default">В этом ЖК подходящих предложений нет</ArticleHeading4>
      </div>
      <div className={styles['text']}>
        <ArticleParagraph2 color={'gray60_100'} textAlign={'center'}>
          Попробуйте поискать в других
        </ArticleParagraph2>
      </div>
      <LinkButton theme="fill_secondary" size="XS" href="https://www.cian.ru/skidki/">
        Посмотреть все скидки и акции
      </LinkButton>
    </div>
  );
}
